<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25.387" height="28.473" viewBox="0 0 25.387 28.473" class="el-icon">
		<g transform="translate(0.75 0.75)">
			<path
				data-name="Rectangle 597"
				d="M10.326,6.136H3.462a2.19,2.19,0,0,0-2.19,2.19v6.85H25.159V8.327a2.19,2.19,0,0,0-2.19-2.19H16.11"
				transform="translate(-1.272 5.146)"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.5"
			/>
			<path
				data-name="Rectangle 598"
				d="M1.272,16.915V10.264H25.159v6.651"
				transform="translate(-1.272 10.058)"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.5"
			/>
			<path
				data-name="Vector 1085"
				d="M16.624,9.434,11.67,14.387a1.1,1.1,0,0,1-1.549,0L3.542,7.808a1.1,1.1,0,0,1,0-1.549L8.5,1.306a1.1,1.1,0,0,1,1.549,0l6.579,6.579a1.1,1.1,0,0,1,0,1.549Z"
				transform="translate(1.048 -0.985)"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.5"
			/>
			<path
				data-name="Vector 1086"
				d="M4.87,8.2H13"
				transform="translate(3.01 7.602)"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.5"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'decisionIcon',
	data() {
		return {};
	},
	props: {
		color: {
			type: String,
			default: '#fff',
		},
	},
};
</script>
